/**
 * ============================================================================
 * HomeBelowFoldSections
 * ============================================================================
 *
 * Purpose: Map controller section config → section registry.
 * Sections render when the Suspense stream resolves (data-ready).
 * Registry uses static imports so CSS is inlined (not preload/blocking chunks).
 * No IntersectionObserver — avoids scroll-time state updates that hurt INP.
 * ============================================================================
 */

"use client";

import { memo, type ComponentType } from "react";
import type {
  HomeLazySectionConfig,
  HomeLazySectionType,
} from "../model/homepage.types";
import { HomePageSection } from "./HomePageSections";
import { HOME_LAZY_SECTION_MAP } from "./home-dynamic";

interface HomeBelowFoldSectionsProps {
  sections: HomeLazySectionConfig[];
}

function HomeBelowFoldSectionsBase({
  sections,
}: HomeBelowFoldSectionsProps) {
  return (
    <>
      {sections.map((section, index) => {
        const SectionComponent = HOME_LAZY_SECTION_MAP[
          section.type as HomeLazySectionType
        ] as ComponentType<Record<string, unknown>> | undefined;

        if (!SectionComponent) return null;

        const props = (section.componentProps ?? {}) as Record<string, unknown>;

        return (
          <HomePageSection
            key={`${section.type}-${index}`}
            section={section.type}
          >
            <SectionComponent {...props} />
          </HomePageSection>
        );
      })}
    </>
  );
}

const HomeBelowFoldSections = memo(HomeBelowFoldSectionsBase);
HomeBelowFoldSections.displayName = "HomeBelowFoldSections";

export default HomeBelowFoldSections;
